<marketplace-header
  #header
  [ngClass]="{ '!tw-h-0': (headerState$ | async) === false }"
  class="tw-sticky tw-top-0 tw-z-20 tw-flex tw-h-[60px] tw-w-screen tw-items-end tw-transition-height tw-duration-200 tw-ease-in-out lg:tw-relative lg:tw-h-full"></marketplace-header>
<mat-drawer-container
  [hasBackdrop]="filtersActive"
  class="tw-duration-200 tw-ease-in-out"
  [ngClass]="{
    'fullheight-minus-header': (headerState$ | async) === true,
    fullheight: (headerState$ | async) === false,
    'hide-overflow': (overflowState$ | async) === false
  }">
  <mat-drawer #drawer [mode]="isMobile ? 'over' : 'side'" position="start" [(opened)]="sidebarVisible" disableClose [@.disabled]="!isMobile">
    <ate-ui-sidebar (outsideClick)="!isMobile || closeSidebar()" [displayCloseBar]="isMobile" [isMobile]="isMobile" #sidebar></ate-ui-sidebar>
  </mat-drawer>
  <div #container class="page-content">
    <div
      [ngClass]="{
        'hide-footer': (footerState$ | async) === footerState.Hide,
        'full-page-view': isFullPageView$ | async
      }">
      <router-outlet></router-outlet>
    </div>
  </div>
  <ate-footer-basic *ngIf="(footerState$ | async) === footerState.Show">
    <div>© {{ currentDate | date: 'yyyy' }} Add to Event Ltd.</div>
  </ate-footer-basic>

  <mat-drawer
    #drawerFilters
    position="end"
    mode="over"
    [class.standard-width]="isMobile && showNotificationsDrawer"
    [opened]="endDrawerOpen"
    (openedChange)="onEndDrawerOpenChange($event)"
    [disableClose]="showNotificationsDrawer">
    @if (showNotificationsDrawer) {
      <app-notifications-sidebar
        (outsideClick)="closeNotificationsSidebar()"
        [notifications]="notifications$ | async"
        id="app-menu-sidebar"
        [isSupplier]="isSupplier$ | async">
      </app-notifications-sidebar>
    } @else {
      <marketplace-sidebar class="h100"></marketplace-sidebar>
    }
  </mat-drawer>
</mat-drawer-container>
